module.exports = __webpack_public_path__ + "img/gasgrill.865dac34.jpg";